import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AdvForm from '../../CommonComponents/AdvForm';

class YesOrNoCheckbox extends Component {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
  }

  onClick(what) {
    const { onClick } = this.props;

    return () => {
      onClick({
        target: {
          checked: what,
        },
      });
    };
  }

  render() {
    const { checked } = this.props;

    return (
      <AdvForm>
        <ul className="horizontal school-list">
          <li className="school-item">
            <div onKeyDown={() => {}} role="button" tabIndex="-1" onClick={this.onClick(true)}>
              <div
                className={`school-item__button-radio-empty${checked === true ? ' selected' : ''}`}
              />
              <button type="button" className="school-item__button" aria-pressed={!!checked}>
                Yes
              </button>
            </div>
          </li>
          <li className="school-item">
            <div onKeyDown={() => {}} role="button" tabIndex="-1" onClick={this.onClick(false)}>
              <div
                className={`school-item__button-radio-empty${checked === false ? ' selected' : ''}`}
              />
              <button
                type="button"
                className="school-item__button"
                aria-pressed={checked === null ? false : !checked}
              >
                No
              </button>
            </div>
          </li>
        </ul>
      </AdvForm>
    );
  }
}

YesOrNoCheckbox.defaultProps = {
  checked: null,
};

YesOrNoCheckbox.propTypes = {
  onClick: PropTypes.func.isRequired,
  checked: PropTypes.bool,
};

export default YesOrNoCheckbox;
